import type { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Subscription: {
    fields: {
      asset: {
        merge: false,
      },
    },
  },
};
